<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/07_Chapter01">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter02">Materials</a></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Setting up your workspace</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Starting to draw</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Pastel techniques</span></h2>
<h2 class="toc1"><span class="bold">Bauble – step by step</span></h2>
<h2 class="toc1"><span class="bold">Teasel – step by step</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Colour</span></h2>
<h2 class="toc1"><span class="bold">Rolling Fields – step by step</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Landscapes</span></h2>
<h2 class="toc1"><span class="bold">Rocky Tor – step by step</span></h2>
<h2 class="toc1"><span class="bold">Billowing Clouds – step by step</span></h2>
<h2 class="toc1"><span class="bold">The Birches – step by step</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Life in your paintings</span></h2>
<h2 class="toc1"><span class="bold">Gone Fishing – step by step</span></h2>
<h2 class="toc1"><span class="bold">Toby – step by step</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Composition</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Index" title="Link target outside of Sample">Index</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?2164fda3